import { harvestYearDetail } from "../../config/harvestYearDetail";
import { globalApiHandler } from "../../services/services";

export const TICKET = {
    getTicketList: {
        success : "GET_TICKET_LIST"
    },
    getTicketDetails : {
        success: "GET_TICKET_DETAILS"
    },
    postTicketDetails : {
        success: "POST_TICKET_DETAILS"
    },
    setReconcileSuccess : {
        success: "SET_RECONCILE_SUCESS"
    },
    upDateTicketDetails : {
        success: "UPDATE_RECONCILE_SUCCESS"
    },
    getReconciledTicketDetails : {
        success: "GET_RECONCILE_SUCCESS"
    },
    emptyStateOnReconciliation : {
        success: "EMPTY_STATE"
    },
    deleteReconciledTicketDetails : {
        success: "DELETE_RECONCILE_SUCCESS"
    }
}


export const updateTicket  = (ticketInfo) => {
    // let url =  `/ntrac/ticket/ticketnum/${ticketInfo.ticketNumber}`
    // return dispatch => {
    //     globalApiHandler(url, "put", ticketInfo).then(response => {
    //         dispatch({type : TICKET.edit.success, data: response.data})
    //         dispatch({type: "SERVER_SUCCESS", data: response.data})
    //     }).catch((err)=>{
    //         dispatch({type: "SERVER_ERROR", data: err.data})
    //     })
    // }
}

export const getTicketList = (startDate, endDate, SubFarmId, harvestYear=harvestYearDetail().name) => {
    console.log(startDate,endDate,SubFarmId)
    let url = ''
    if( startDate && endDate) {
        url = `/ntrac/reconciliation/getTicketNumber?startDate=${startDate}&endDate=${endDate}&farmId=${SubFarmId}&harvestYear=${harvestYear}`
    }
    else {
        url = `/ntrac/reconciliation/getTicketNumber?farmId=${SubFarmId}&harvestYear=${harvestYear}`
    }
    return dispatch => {
        globalApiHandler(url, "get").then(response => {
            const data = response.data.data
            const finalData = data.map((value)=>{
                // let obj = {}
                value["name"] = value.ticketNumber
                value["id"] = value.ticketNumber
                return value
            })
            dispatch({ type: TICKET.getTicketList.success, data: finalData })
            // dispatch({type: "SERVER_SUCCESS", data: response.data}
        }).catch((err)=>{
            dispatch({type: "SERVER_ERROR", data: err.data})
        })
    }
}

export const getTicketDetails = (ticketNumber) => {
    let url = `/ntrac/reconciliation/get/${ticketNumber}`
    return dispatch => {
      return  globalApiHandler(url, "get").then(response => {
            const data = response.data.data
            dispatch({type:TICKET.getTicketDetails.success, data})
            return true
        }).catch((err)=>{
            dispatch({type: "SERVER_ERROR", data: err.data})
            return false
        })
    }
}

export const postTicketDetails = (ticketNumber, reconcileInfo) => {
    let url = `/ntrac/reconciliation/${ticketNumber}`
    return dispatch => {
       return globalApiHandler(url, "post",reconcileInfo).then(response => {
            const data = response.data.data
            dispatch({type:TICKET.setReconcileSuccess.success, data})
            dispatch({type: "SERVER_SUCCESS", data: response.data})
            return true
        }).catch((err)=>{
            dispatch({type: "SERVER_ERROR", data: err.data})
            return false
        })
    }
}

export const upDateTicketDetails = (ticketNumber, reconcileInfo) => {
    let url = `/ntrac/reconciliation/${ticketNumber}`
    return dispatch => {
        return  globalApiHandler(url, "put",reconcileInfo).then(response => {
            const data = response.data.data
            dispatch({type:TICKET.upDateTicketDetails.success, data})
            dispatch({type: "SERVER_SUCCESS", data: response.data})
            return true
        }).catch((err)=>{
            dispatch({type: "SERVER_ERROR", data: err.data})
            return false
        })
    }
}

export const getReconciledTicketDetails = (ticketNumber) => {
    let url = `/ntrac/reconciliation/getreconciliation/${ticketNumber}`
    return dispatch => {
        globalApiHandler(url, "get").then(response => {
            const data = response.data.data
            dispatch({type:TICKET.getReconciledTicketDetails.success, data})
            // dispatch({type: "SERVER_SUCCESS", data: response.data})
        }).catch((err)=>{
            dispatch({type: "SERVER_ERROR", data: err.data})
        })
    }
}

export const emptyStateOnReconciliation = () => {
    return dispatch => {
        dispatch({type:TICKET.emptyStateOnReconciliation.success})
        return true
    }
}

export const deleteReconciledTicketDetails = (ticketNumber) => {
    let url = `/ntrac/reconciliation/${ticketNumber}`
    return dispatch => {
        return  globalApiHandler(url, "delete",{}).then(response => {
            const data = response.data.data
            dispatch({type:TICKET.deleteReconciledTicketDetails.success, data})
            dispatch({type: "SERVER_SUCCESS", data: response.data})
            return true
        }).catch((err)=>{
            dispatch({type: "SERVER_ERROR", data: err.data})
            return false
        })
    }
}


// WEBPACK FOOTER //
// ./src/modules/reconciliation/action.js